import React from 'react';
import "./Background.css"
import {Parallax, ParallaxProvider} from 'react-scroll-parallax';
import Box from "@mui/material/Box";
function Background(props) {
    console.log(props.heights)

    return (
        <Box sx={{ overflow: 'hidden', width: '100%' }}>
            {/* First background layer */}
            <Box
                sx={{
                    position: 'absolute',
                    top: props.heights[0]+ "px",
                    left: 0,
                    width: '100%',
                    padding: 0,
                    margin: 0,
                }}
            >
                <Box
                    sx={{
                        height: (props.heights[1] - props.heights[0])+ "px",
                        width: '100%',
                        transform: 'skew(0deg, 14deg)',
                        backgroundColor: 'var(--primary_container)',
                        padding: 0,
                        margin: 0,
                    }}
                />
            </Box>

            {/* Second background layer */}
            <Box
                sx={{
                    position: 'absolute',
                    top: props.heights [1]+ "px",
                    left: 0,
                    width: '100%',
                    padding: 0,
                    margin: 0,
                }}
            >
                <Box
                    sx={{
                        height: (props.heights[2]- props.heights[1]) + "px" ,

                        width: '100%',
                        transform: 'skew(0deg, 14deg)',
                        backgroundColor: 'var(--primary)',
                        padding: 0,
                        margin: 0,
                    }}
                />
            </Box>
        </Box>
    );
}


export default Background;